<template>
  <div id="service-content" class="p-6">
    <div slot="header" class="flex justify-between pb-6">
      <h3 class="font-bold">Combo</h3>
      <div class="flex">
        <div class="select-staff">
          <v-select @input="selectId($event)" :value="selected" label="name" :options="filterStatusList" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" />
        </div>
        <vs-button
          type="border"
          color="primary"
          icon-pack="feather"
          icon="icon-plus"
          class="ml-4 gradient gradient-primary no-shadow"
          @click="addCombo"
        >Add Combo</vs-button>
      </div>
    </div>

    <div class="service-list-content">
      <div class="service-header flex p-6 text-sm font-bold">
        <div class="w-1/12 px-2"></div>
        <div class="w-3/12 px-2 text-uppercase">Combo Name</div>
        <div class="w-4/12 px-2 text-uppercase text-center">Price</div>
        <div class="w-2/12 px-2 text-uppercase text-center">Active</div>
        <div class="w-2/12 px-2 text-uppercase text-center">Action</div>
      </div>
      <draggable v-model="dragList" :scroll-sensitivity="250" :force-fallback="true" handle=".move-btn" @end="getOrderList" v-if="dragList && dragList.length > 0 && !isEmptyList">
        <transition-group>
          <div class="service-item align-center p-5 mb-5 shadow-sm" v-for="item in dragList" :key="item.id" @click="editProduct(item)">
            <div class="flex">
              <div class="w-1/12 px-2 leading-none">
                <feather-icon icon="MoveIcon" svgClasses="w-5 stroke-current cursor-pointer icon-group move-btn"/>
              </div>
              <div class="w-3/12 px-2">
                <p class="product-name font-medium truncate service-name">{{item.name}}</p>
              </div>
              <div class="w-4/12 px-2">
                <div v-if="item.price != null">
                  <p class="product-name font-medium truncate text-center">${{item.price}}</p>
                </div>
                <div v-else>
                  <p class="product-name font-medium truncate text-center">N/A</p>
                </div>
              </div>
              <div class="w-2/12 px-2">
                <div class="text-center" v-if="item.status == 1">
                  <feather-icon icon="CheckIcon" svgClasses="w-6 h-6 stroke-current text-primary" />
                </div>
                <div class="text-center" v-else>
                  <feather-icon icon="XIcon" svgClasses="w-6 h-6 stroke-current text-danger" />
                </div>
              </div>
              <div class="w-2/12 px-2 flex justify-center">
                <!-- <vs-button @click.stop="openDeleteServicePopup(item)" type="filled" size="small" icon-pack="feather" icon="icon-trash" color="orange" style="min-width: 28px;"></vs-button> -->
                <img src="../../assets/images/pen-icon-grey.png" class="cursor-pointer icon-group pen-icon" @click.stop="editCombo(item)">
                <img src="../../assets/images/trash-icon.png" class="ml-6 trash-icon cursor-pointer" @click.stop="openDeleteServicePopup(item)" />
              </div>
            </div>
            <div v-if="showDetail && id_show == item.id">
              <hr class="ml-12 mr-4 mt-4 mb-2">
              <div v-for="combo_item in item.combo_item" :key="combo_item.id" class="flex">
                <div class="w-1/12 px-2"></div>
                <div class="w-5/12 px-2 py-2" v-if="combo_item.item_detail">
                  <p class="truncate combo-item">{{combo_item.item_detail.name}}</p>
                </div>
                <div class="w-4/12 px-2 py-2" v-if="combo_item.item_detail">
                  <div v-if="combo_item.price != null">
                    <p class="truncate text-center combo-item">${{combo_item.price}}</p>
                  </div>
                  <div v-else>
                    <p class="truncate text-center combo-item">N/A</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </draggable>
      <div v-else class="p-base text-center">
        No data available
      </div>
    </div>
    <vs-popup class="holamundo delete-group delete-popup" title="Delete Combo" :active.sync="popupActive">
      <div class="text-center">
          <h3>Do you want to delete this combo?</h3>
          <div class="flex flex-wrap justify-center align-center p-6 mt-6">
          <vs-button class="mr-6 align-center delete-responsive" @click="deleteService(activeService)">Delete</vs-button>
          <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupActive = false">Cancel</vs-button>
          </div>
      </div>
  </vs-popup>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from 'vue-select'
export default {
  name: "combo-content",
  components: {
    VuePerfectScrollbar,
    draggable,
    vSelect
  },
  data(){
    return{
      popupActive: false,
      settings: {
          maxScrollbarLength : 60,
          wheelSpeed         : 0.70,
      },
      itemsPerPage:10,
      activeService: {},
      dragList: [],
      orderedList : [],
      showDetail: false,
      id_show: 0,
      filterStatusList: [
        {
          id: 2,
          name: 'All'
        },
        {
          id: 1,
          name: 'Active'
        },
        {
          id: 0,
          name: 'InActive'
        },
      ],
      selected: {id: 1, name: 'Active'},
    }
  },
  props: {
    servicesList: {
      type: Array,
      required: true
    },
    activeCategory: {
      type: Object,
      required: true
    },
    isEmptyList: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    servicesList: {
      immediate: true,
      deep: true,
      handler: function() {
        this.dragList = this.servicesList;
      }
    },
  },
  methods: {
    selectId(e) {
      this.selected.id = e.id
      this.selected.name = e.name
      this.$emit("GetListByStatus", {id: this.selected.id})
    },
    getOrderList(){
      this.orderedList = [];
      for(let i = 0 ; i < this.dragList.length; i++){
        this.orderedList.push(this.dragList[i].id);
      }
      const obj = {
        items: this.orderedList.length > 0 ? String(this.orderedList) : '',
        // services: this.orderedList.length > 0 ? String(this.orderedList) : '',
        // cate_id: this.activeCategory.id
      }
      this.openLoadingInDiv();
      this.$store.dispatch("serviceList/DRAG_PRODUCT", obj).then(() => {
        let temp = {
          category_id: this.activeCategory.id,
          status: this.selected.id
        }
        this.$store.dispatch("serviceList/GET_COMBO_LIST_POS", temp).then(() => {
          this.closeLoading();
        })
      });
    },
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if(this.loadTime){
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: 'Delete service failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.isOpenLoading = false;
      setTimeout( ()=> {
        this.$vs.loading.close('#app > .con-vs-loading')
      }, 700)
    },
    addCombo() {
      this.$emit("AddCombo");
    },
    handleFileChange(e){
      this.$store.dispatch("serviceList/IMPORT_SERVICE", e.target.files[0]).then(()=>{
        console.log('uploaded');
      }).catch((error)=>{console.log(error)});
    },
    editProduct(cate){
      cate.category_id = this.activeCategory.id
      this.showDetail = !this.showDetail
      this.id_show = cate.id
    },
    deleteService(cate){
      const obj ={
        id: cate.id,
        category_id: this.activeCategory.id,
        status: 'delete',
        statusFilter : this.selected.id
      }
      this.openLoadingInDiv();
      this.popupActive = false;
      this.$store.dispatch("serviceList/DELETE_COMBO_POS", obj).then(() => {
        this.closeLoading();
        this.$vs.notify({
          title:'Notification',
          text:'Delete Combo Success',
          color:'success',
          position:'top-right'})
      }).catch(() => {
        this.closeLoading();
        this.$vs.notify({
          title:'Notification',
          text:'Delete Combo Failed',
          color:'danger',
          position:'top-right'})
      })
    },
    closePopup(){
      this.popupActive = false;
    },
    openDeleteServicePopup(service) {
      this.activeService = service;
      this.popupActive = true;
    },
    editCombo(item){
      this.$emit("UpdateCombo", item);
    }
  },
  created() {
    this.$store.dispatch("staffList/GET_SERVICE_LIST", {page: 1, "per-page": 100});
  }
};
</script>

<style lang="scss">
  @import '@/assets/scss/vuexy/_variables';
  @import "@/assets/scss/custom/staff/_staff.scss";
  #service-content{
    .select-staff{
      margin-left: 17px;
      // width: 150px;
      width: 110px;
      .v-select {
          height: 43px;
          .vs__dropdown-toggle {
              height: 100%;
              border-radius: 8px;
              background: #fff;
              border: 1px solid #aaa;

              .vs__selected {
                // color: #aaa;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-top: 7px;
                margin-right: 0;
                padding-left: 10px;
              }

              .vs__open-indicator {
                color: #AAA;
                padding-right: 2px;
              }
          }
          .vs__dropdown-menu {
            height: 110px;
            min-width: 110px;
            top: 110%;
            border-radius: 8px;
            border: 1px solid #aaa;
            padding: 0;
            // overflow: hidden;
            &::-webkit-scrollbar, &::-webkit-scrollbar-track, &::-webkit-scrollbar-thumb {
              border-top-right-radius: 8px !important;
              border-bottom-right-radius: 8px !important;
            }

            li {
              padding-top: 8px;
              padding-bottom: 8px;
              padding-left: 16px;
              width: inherit;
              overflow-x: auto;
            }
          }
      }
    }
  }
</style>
